import React from "react";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import styled from "@emotion/styled";
import Tooltip from "@material-ui/core/Tooltip";

const WhatsAppClick = () => {
  const openWhatsapp = () => {
    const url =
      "https://api.whatsapp.com/send?phone=972523114805&text=היי%20אשמח%20לשמוע%20מהסטודיו%20";
    window.open(url, "_blank");
  };

  return (
    <Tooltip title="אנחנו כאן בשבילך">
      <Container onClick={openWhatsapp}>
        <WhatsAppIcon htmlColor="white" fontSize="large" />
      </Container>
    </Tooltip>
  );
};

export default WhatsAppClick;

const Container = styled.div`
  position: fixed;
  bottom: 15px;
  cursor: pointer;
  right: 0;
  left: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 50%;
  background-color: #25d366;
  width: 70px;
  height: 70px;
`;
